module.exports = __webpack_public_path__ + "media/images/flags/1x1/mrt-b8edb8f44060c76d6255ee7c62d175b2.svg";